import { Dispatch, SetStateAction } from 'react';

import { getListPayload } from 'coreOld/utils';
import { useGetUsers } from 'system/hooks';
import { ISystemUser } from 'system/types';

import { columns } from './columns';
import UsersManagerView from './UsersManagerView';

interface IProps {
  filters?: Record<string, any>;
  setSelectedRows?: Dispatch<SetStateAction<ISystemUser[]>>;
  onCheckboxClick?: () => void;
  isModalOpen?: boolean;
}

const UsersManager = ({ filters, setSelectedRows, onCheckboxClick, isModalOpen }: IProps) => {
  const {
    records,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isFetching,
    isFetchingNextPage,
    isError,
    statusCode,
  } = useGetUsers(getListPayload(filters));

  return (
    <UsersManagerView
      tableColumns={columns}
      users={records}
      isLoading={isLoading || (isFetching && !isFetchingNextPage)}
      isError={isError}
      statusCode={statusCode}
      hasNextPage={hasNextPage}
      fetchNextPage={fetchNextPage}
      isFetchingNextPage={isFetchingNextPage}
      setSelectedRows={setSelectedRows}
      onCheckboxClick={onCheckboxClick}
      isModalOpen={isModalOpen}
    />
  );
};

export default UsersManager;
